'use client';

import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import { ArrowRight } from 'lucide-react';
import { PurchaseJourneyFunnel } from '@/components/demand/PurchaseJourneyFunnel';
export function DemandSection() {
  const $ = _c(6);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="pointer-events-none absolute inset-0" aria-hidden="true"><div className="absolute -left-32 -top-40 h-[26rem] w-[26rem] rounded-full bg-primary-500/20 blur-[110px]" /><div className="absolute -bottom-48 -right-32 h-[30rem] w-[30rem] rounded-full bg-orange-500/15 blur-[110px]" /><div className="absolute inset-0 opacity-[0.08] [background-image:linear-gradient(to_right,rgba(255,255,255,0.5)_1px,transparent_1px),linear-gradient(to_bottom,rgba(255,255,255,0.5)_1px,transparent_1px)] [background-size:64px_64px] [mask-image:radial-gradient(ellipse_60%_50%_at_50%_40%,black,transparent)]" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="mb-10 flex flex-col gap-6 lg:mb-14 lg:flex-row lg:items-end lg:justify-between"><div className="max-w-2xl"><h2 className="text-3xl font-black leading-[1.05] tracking-tight text-white sm:text-4xl lg:text-5xl">No Demand, No Sales.</h2><p className="mt-4 text-base leading-7 text-gray-400 sm:text-lg">Learn how people navigate the purchase journey and master helping them become aware through to being an champion. Sizzle helps you with your next moves.</p></div></div>;
    t2 = <PurchaseJourneyFunnel showHeader={false} variant="light" />;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <p className="text-lg font-bold text-white sm:text-xl">Build awareness, drive trial, convert to purchase, and measure what works.</p>;
    t4 = <p className="mt-2 text-base text-gray-400">Demand Central brings the full funnel into one place.</p>;
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <section className="relative isolate overflow-hidden bg-gradient-to-br from-gray-950 via-gray-900 to-gray-950 py-14 sm:py-20 lg:py-24">{t0}<div className="relative mx-auto max-w-[1320px] px-5 sm:px-8 lg:px-12">{t1}{t2}<div className="mt-12 text-center">{t3}{t4}<Link href="/demand" className="mt-6 inline-flex cursor-pointer items-center justify-center gap-2 rounded-full bg-[#ff5a36] px-8 py-4 text-lg font-black text-white shadow-lg shadow-red-500/20 transition-all duration-300 hover:-translate-y-0.5 hover:shadow-xl hover:shadow-red-500/30">Demand Central<ArrowRight className="h-5 w-5" aria-hidden="true" /></Link></div></div></section>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
}